import { UserGroup } from './user-group';
import { Credentials } from './credentials';

export class User {
    UserId: number;
    DisplayName: string;
    PartnerId: number;
    Credentials: Credentials = new Credentials();
    EmailAddress: string;
    UserGroups: UserGroup[] = [];
    IsDeleted: boolean;
    IsDisabled: boolean;
    IsBuiltIn: boolean;
    LastActivity: Date | null;

    public static hasPermission(permissionTypeName: string, user: User): boolean {
        return user.UserGroups.some(g => g.Roles.some(r => r.Permissions.some(p => p.PermissionType === permissionTypeName)));
    }

    public static hasUserGroup(groupName: string, user: User): boolean {
        return user.UserGroups.some(g => g.Name === groupName);
    }

    public static hasRole(roleName: string, user: User): boolean {
        return user.UserGroups.some(g => g.Roles.some(r => r.RoleName === roleName));
    }
}
